import { EN_TICKET_OPTION_STATUS_TYPE } from '@@sapporo/constant/enum/ticket/EN_TICKET_OPTION_STATUS_TYPE';
import { ITicketCommon } from '@@sapporo/ticket/interface/ITicketCommon';
import { ITicketCommonV3 } from '@/models/Leisure/interfaces/payloads/ILeisureProductsPayload';
import { numberFormat } from '@/utils';
import clsx from 'clsx';
import { prop } from 'ramda';
import React from 'react';

import styles from './LeisurePriceOrigin.module.scss';

interface ILeisurePriceOriginProps {
  item: ITicketCommon | ITicketCommonV3;
  className?: string;
}

const LeisurePriceOrigin: React.FC<ILeisurePriceOriginProps> = ({ className, item }) => {
  const isOnSale = prop('type', item.status) === EN_TICKET_OPTION_STATUS_TYPE.SALE;
  const amount = isOnSale && item.price.origin?.amount ? numberFormat(item.price.origin?.amount) : '';

  return (
    <div className={clsx(styles.wrap, className)}>
      <s>{amount}</s>
    </div>
  );
};

export default LeisurePriceOrigin;
